<template>
    <div class="row cartasConVinculos">
        <div v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" v-bind:class="CreaLaClaseDeCol(contenidoDeLaPaginaWeb.TamanoDelContenido != null ? contenidoDeLaPaginaWeb.TamanoDelContenido : seccionDeLaPaginaWeb.TamanoDeMiDescendiente)">
            <a v-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && !ArchivosEnVisor(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb).verEnVisor"  v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb), '_self');">
                <p>{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</p>
            </a>
            <a v-else-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0 && ArchivosEnVisor(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb).verEnVisor" v-on:click="MostrarVisor(ArchivosEnVisor(contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb).archivo)">
                <p>{{contenidoDeLaPaginaWeb.TextoDelVinculo}} </p>
            </a>
            <a v-else-if="contenidoDeLaPaginaWeb.Vinculo.includes('http') || contenidoDeLaPaginaWeb.Vinculo.includes('https')" :href="contenidoDeLaPaginaWeb.Vinculo" target="_blank">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
            <router-link v-else :to="contenidoDeLaPaginaWeb.Vinculo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</router-link>
        </div>
    </div>
</template>

<script>
  import comun from "@/../static/js/comun";
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
  
    data() { 
      return {
        TIPO_ROL_DE_ARCHIVO: 1,

      }
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        MostrarVisor: function(archivo) {
         // console.log("archivoooo:::",archivo)
           this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor',archivo.RutaDeArchivoCarpeta);//RutaDelArchivo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));      
        },

        ArchivosEnVisor(archivos){
             let infoArchivo ={
               verEnVisor:false,
               archivo:null
             } 
          if(archivos != null && archivos != undefined && archivos.length > 0)
                archivos.forEach(archivo => {           
                    if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId && archivo.MostrarEnVisor){                                       
                      infoArchivo.verEnVisor = true
                      infoArchivo.archivo = archivo
                    }
          });
          return infoArchivo ;     
        },



        ObtenLaRutaDeDescarga: function(archivos) {    
          let rutaDeDescarga = "";
            if(archivos != null && archivos != undefined && archivos.length > 0)
                archivos.forEach(archivo => {
                    if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId)
                    rutaDeDescarga = archivo.RutaDeArchivoCarpeta;
                });

            return rutaDeDescarga;
        },
        AbrirDocumento: function(vinculo, formaDeApertura) { debugger
        //  console.log("vinculo::::",vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta))
            comun.DescargarDocumentoPDF(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta));
           // window.open(vinculo, formaDeApertura);
        }, 
        CreaLaClaseDeCol: function(tamanoDeLaColumna) {
            return "col-md-" + tamanoDeLaColumna + " col-" + tamanoDeLaColumna;
        }
    }
}
</script>

<style scoped>
  a {
    color: rgb(33,33,33);
    font-weight: 500;
    cursor: pointer;
  }

  .cartasConVinculos {
    margin-left: 30px;
    margin-right: 30px;
    overflow: hidden;
  }
    .cartasConVinculos div {
      font-size: 2.4em;
      text-align: center;
      padding: 1.4em 0;
      transition: all 1s;
    }

    .cartasConVinculos div:hover {
      transform: scale(1.2)
    }

      .cartasConVinculos div a p {
        margin-left: 10%;
        margin-right: 10%;
      }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/CartasConVinculos.vue